import React from "react";
import { colors } from "../../theme/theme";
import {
  FormControl,
  OutlinedInput,
  InputAdornment,
  Select,
  MenuItem,
  Box,
  Grid,
  Typography,
  Button,
  Switch,
  IconButton,
  InputLabel,
  TextField,
} from "@mui/material";
import {
  Add,
  Check,
  EditOutlined,
  MyLocationSharp,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
export const CreateDropDown = ({
  value,
  setValue,
  title,
  data,
  Icon,
  noIcon,
  readOnly,
}) => {
  const [open, setOpen] = React.useState(false);

  const handleChange = (event) => {
    setValue(event.target.value);
    setOpen(false);
  };

  return (
    <FormControl fullWidth disabled={readOnly}>
      <InputLabel id="dropdown-label">{title}</InputLabel>
      <Select
        labelId="dropdown-label"
        displayEmpty
        disabled={data?.length === 0 || readOnly}
        value={value}
        onChange={handleChange}
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        input={<OutlinedInput label={title} />}
        sx={{
          height: "32px",
          borderRadius: "8px",
          backgroundColor: "#f6f3f0",
          fontSize: "10px",
          fontWeight: 400,
          color: "#000",
          ".MuiSvgIcon-root": {
            fill: "black !important",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#FBBDB0", // Change border to red on hover
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#FBBDB0 !important", // Change border to red on focus
          },
        }}
        inputProps={{
          sx: {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#707173",
            },
          },
        }}
        startAdornment={
          <InputAdornment position="start">
            <MyLocationSharp
              sx={{ color: "#4FCE00", height: "12px", width: "12px" }}
            />
            {/* <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/65/Flag_of_Qatar.svg" // Qatar flag image
              alt="Qatar"
              style={{ width: 20, height: 14, marginRight: 8 }}
            /> */}
          </InputAdornment>
        }
      >
        {data?.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
export const CustomFormInput = ({
  value,
  setValue,
  placeholder,
  mT,
  mB,
  Icon,
  password,
  type,
  readOnly,
}) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  return (
    <FormControl fullWidth sx={{ mt: mT ? 2 : 0, mb: mB ? 2 : 0 }}>
      <TextField
        sx={{
          backgroundColor: "#fff",
          fontFamily: "FiraSans",
          fontSize: "14px",
          fontWeight: "400",
          borderRadius: "8px",
          mt: 2,
        }}
        placeholder={placeholder}
        label={placeholder}
        value={value}
        disabled={readOnly}
        onChange={(e) => setValue(e.target.value)}
        type={password && !showPassword ? "password" : type ? type : "text"}
        inputProps={{
          autoComplete: "none",
          sx: {
            height: "50px",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E0E2E7",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#A0A2A7",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#707173",
            },
            "& .MuiInputAdornment-root": {
              color: value === "" ? "#707173" : colors.text,
            },
          },
          startAdornment: (
            <>
              {Icon && (
                <InputAdornment position="start">
                  <Icon sx={{ color: colors.text }} />
                </InputAdornment>
              )}
            </>
          ),
          endAdornment: (
            <>
              {password && (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )}
            </>
          ),
        }}
        InputLabelProps={{
          sx: {
            "&.Mui-focused": {
              color: "#138418",
            },
          },
        }}
      />
    </FormControl>
  );
};
